import { render } from "./TeamingTextarea.vue?vue&type=template&id=8f16b81c&scoped=true"
import script from "./TeamingTextarea.vue?vue&type=script&lang=js"
export * from "./TeamingTextarea.vue?vue&type=script&lang=js"

import "./TeamingTextarea.vue?vue&type=style&index=0&id=8f16b81c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f16b81c"

export default script